export enum IntegrationErrorType {
  AUTHENTICATION_FAILURE = 'AUTHENTICATION_FAILURE',
  CLIENT_FAILURE = 'CLIENT_FAILURE',
  INTEGRATION_FAILURE = 'INTEGRATION_FAILURE',
}

export enum IntegrationDataErrorType {
  ACCOUNT_ADMIN_DISABLED = 'ACCOUNT_ADMIN_DISABLED',
  DUPLICATE_ETHENA_USER_MATCH = 'DUPLICATE_ETHENA_USER_MATCH',
  DUPLICATE_PARTNERSHIP_EMAIL = 'DUPLICATE_PARTNERSHIP_EMAIL',
  INVALID_DATA = 'INVALID_DATA',
  LEAVE_ALREADY_STARTED = 'LEAVE_ALREADY_STARTED',
  MANAGER_NOT_FOUND = 'MANAGER_NOT_FOUND',
  MISSING_REQUIRED_INFORMATION = 'MISSING_REQUIRED_INFORMATION',
}

export interface IPartnershipErrorData {
  errorType?: string;
  errorMessage: string;
  errorDetails: Record<string, unknown>;
}
